// @ts-nocheck
import React from 'react'
import * as R from 'ramda'
import FormField from '../FormField'
// import { validate } from './validate'
import { connect } from 'react-redux'

const ModelFormField = ({
  name,
  gridArea = false,
  errors,
  isDirty,
  validators,
  value,
  defaultValue,
  setValue,
  ...props
}) => {
  // const validator = validate(validators, props)
  const changeHandler = e => {
    const value = R.pathOr(null, ['target', 'value'], e)
    // const err = errors.length ? validator(value) : errors
    // const action = { value, errors: err }
    setValue(value)
  }
  React.useEffect(() => {
    if (defaultValue && R.isNil(value)) {
      setValue(defaultValue)
    }
    // eslint-disable-next-line
  }, [defaultValue])
  if (gridArea) props = R.assocPath(['style, gridArea'], name, props)

  return (
    <FormField
      name={name}
      value={value || ''}
      onChange={changeHandler}
      errors={errors}
      {...props}
    />
  )
}

const mapStateToProps = (state, { model, pk, name }) =>
  model.getItemValue(state, { pk, name })

const mapDispatchToProps = (dispatch, { model, pk, name }) => {
  return { setValue: value => dispatch(model.change({ pk, [name]: value })) }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModelFormField)
